import { render } from "./devDash.vue?vue&type=template&id=ff2a4dce&scoped=true"
import script from "./devDash.vue?vue&type=script&lang=js"
export * from "./devDash.vue?vue&type=script&lang=js"

import "./devDash.vue?vue&type=style&index=0&id=ff2a4dce&lang=css"
import "./devDash.vue?vue&type=style&index=1&id=ff2a4dce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff2a4dce"]])

export default __exports__